import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {Messages} from '../model/messages';
import {AppService} from '../app.service';
import {TranslateService} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {Message} from '../model/message';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit, OnDestroy {

  data: Messages[];
  messagesData: Subscription;
  show = false;
  loading = true;
  private onMessagesClickSubscription: Subscription;

  constructor(
      private appService: AppService,
      private translate: TranslateService,
      private http: HttpClient
  ) { }

  ngOnInit() {
    this.messagesData = this.appService.messagesData
      .subscribe((data) => {
        this.data = data;
        this.loading = false;
      });

    this.appService.fetchMessages();

    this.onMessagesClickSubscription =
        this.appService.onMessagesClickSubject.subscribe(
            () => {
              this.show = !this.show;
            }
        );
  }

  ngOnDestroy(): void {
    this.messagesData.unsubscribe();
    this.onMessagesClickSubscription.unsubscribe();
  }

  getMessageCount() {
    let count = 0;
    if (this.data) {
      this.data.forEach((m) => {
        count += m.messages.length;
      });
    }
    return count;
  }

  removeGroup($key: string) {
    this.data = this.data.filter(i => i.key !== $key);
  }

  deleteOneMonthOldMessages()
  {
    const message = this.translate.instant('Zmazať všetky notifikácie staršie ako 1 mesiac?');

    const ids: number[] = [];

    const currentDate = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    this.data.forEach((m: Messages) => {
      m.messages.forEach((i) => {
        const messageDate = new Date(i.casVzniku);
        if (messageDate < oneMonthAgo) {
          ids.push(i.id);
        }
      });
    });

    this.appService.openConfirmDialog(message)
        .subscribe((res) => {
          if ('OK' === res) {
            this.loading = true;
            this.http
                .post('/ais/rest/portal/messages/delete-bulk', ids)
                .subscribe(
                    () => {
                      this.appService.fetchMessages(true);
                    }
                );
          }
        });
  }

  deleteAllMessages()
  {
    const message = this.translate.instant('Zmazať všetky notifikácie?');

    const ids: number[] = [];

    this.data.forEach((m: Messages) => {
      m.messages.forEach((i) => {
        ids.push(i.id);
      });
    });

    this.appService.openConfirmDialog(message)
        .subscribe((res) => {
          if ('OK' === res) {
            this.http
                .post('/ais/rest/portal/messages/delete-bulk', ids)
                .subscribe(
                    () => {
                      this.data = [];
                    }
                );
          }
        });
  }

}
